const ContentStatus = {
  ARCHIVED: 'archived',
  DRAFT: 'draft',
  LIVE: 'live',
} as const;

export default ContentStatus;
